import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import List from 'react-virtualized/dist/commonjs/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';

import messages from './AssocAutoCompleteMessage';
import styles from './AssocAutoCompleteListStyle';

class AssocAutoCompleteList extends PureComponent {
    state = {
        filterValue: '',
    }

    onFilterChange = ({ target: { value: filterValue } }) => {
        this.setState({ filterValue });
    }

    render() {
        const {
            id,
            classes,
            values,
            headerLabel,
            removeOption,
            icon,
            intl: { formatMessage },
        } = this.props;

        const { filterValue } = this.state;

        const filteredValues = values.filter((value) => {
            const valueText = validate.isObject(value) ? value.text : value;
            return valueText && RegExp(filterValue, 'i').test(valueText);
        });

        const chipRenderer = ({
            index, key, style, isScrolling,
        }) => {
            let chip = '...';
            if (!isScrolling) {
                const value = filteredValues[index];
                const valueText = validate.isObject(value) ? value.text : value;
                chip = (
                    <Chip
                        id={`${id}_${valueText}`}
                        classes={{
                            root: classes.chip,
                            label: classes.chipLabel,
                        }}
                        onDelete={() => removeOption(index)}
                        avatar={icon && <Avatar>{icon}</Avatar>}
                        label={valueText}
                    />
                );
            }

            return (
                <div key={key} style={style}>
                    {chip}
                </div>
            );
        };

        return (
            <div id={id}>
                <ListSubheader disableSticky classes={{ root: classes.subheader }}>
                    {headerLabel}
                    <TextField
                        id="srtAssocAutoCompleteListTableFilter"
                        style={styles.filter}
                        placeholder={formatMessage(messages.lblFilter)}
                        onChange={this.onFilterChange}
                        value={filterValue}
                    />
                </ListSubheader>
                <AutoSizer disableHeight>
                    {({ width }) => (
                        <List
                            height={240}
                            rowCount={filteredValues.length}
                            rowHeight={42}
                            rowRenderer={chipRenderer}
                            width={width}
                            className={classes.chipContainer}
                        />
                    )}
                </AutoSizer>
            </div>
        );
    }
}

AssocAutoCompleteList.propTypes = {
    id: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    values: PropTypes.array.isRequired,
    headerLabel: PropTypes.string.isRequired,
    removeOption: PropTypes.func.isRequired,
    icon: PropTypes.node.isRequired,
    intl: PropTypes.object.isRequired,
};

export default injectIntl(withStyles(styles)(AssocAutoCompleteList));
